import {RootStore} from '../../stores/RootStore';
import {IPaymentMethodsBannerProps} from '@wix/wixstores-client-storefront-sdk/dist/es/src/viewer-script/wixcode/payments/getPaymentMethodsBannerProps';

// TODO:Zeev: use "|  Promise<IPaymentMethodsBannerProps>" until we can upgrade wixstores-client-storefront-sdk
export const getCashierBannerProps = (
  rootStore: RootStore,
): IPaymentMethodsBannerProps | Promise<IPaymentMethodsBannerProps> => {
  return rootStore.ecomPublicApi.payments.getPaymentMethodsBannerProps({
    productId: rootStore.$state.product.id,
    amount: rootStore.$state.calculatedPrice,
  });
};
